import React from "react";
import Typography from "@mui/material/Typography";
import { ErrorMessageProps } from "types";

// No Strapi field covers error text — every page hardcoded this same
// color/size/weight independently, so it's centralized here instead, driven
// by the theme's error palette (sourced from the tenant's errorColor).
const ErrorMessage = ({ children, sx }: ErrorMessageProps): JSX.Element => (
  <Typography
    component="div"
    sx={[
      { color: "error.main", fontSize: "0.875rem", mb: "1rem", textAlign: "center", fontWeight: 500 },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Typography>
);

export default ErrorMessage;
